import { Outlet } from "react-router-dom";
import { Header } from "../components/layout/Header";
import { RouteErrorBoundary } from "../components/errors/RouteErrorBoundary";

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <main className="mx-auto">
        <RouteErrorBoundary>
          <Outlet />
        </RouteErrorBoundary>
      </main>
    </div>
  );
}
